import React from 'react';
import { format } from 'date-fns';
import LeaderboardWidgetRow from './leaderboard-widget-row';
import LeaderboardWidgetRowTitle from './leaderboard-widget-row-title';
import LeaderboardWidgetFooter from './leaderboard-widget-footer';

const LeaderboardWidget = (
    {
        numberOfCells,
        scoringLeaderboard,
        topPlayersToShowState,
        datePublished,
        titleText,
        players,
        fullLeaderboardLinkText,
        fullLeaderboardLink,
        targetsConfig,
        patronLogo,
        liveComponentLeaderboard,
        liveComponentSubtitle,
    }
) => {
    return (
        <div className="leaderboard-widget__layout">
            {
                liveComponentLeaderboard ?
                    <div className="leaderboard-widget__table">
                        {
                            datePublished &&
                            <div className="leaderboard-widget__pubdate-content">
                                <time className="leaderboard-widget__pubdate">{format(datePublished, 'h:mm a')}</time>
                            </div>
                        }
                        <LeaderboardWidgetRowTitle
                            numberOfCells={numberOfCells}
                            topPlayersToShowState={topPlayersToShowState}
                            titleText={titleText}
                        />
                        {
                            players.map((player) => {
                                return (
                                    <LeaderboardWidgetRow
                                        key={player.id}
                                        scoringLeaderboard={scoringLeaderboard}
                                        player={player}
                                        numberOfCells={numberOfCells}
                                        targetsConfig={targetsConfig}
                                    />
                                );
                            })
                        }
                        <LeaderboardWidgetFooter
                            fullLeaderboardLinkText={fullLeaderboardLinkText}
                            fullLeaderboardLink={fullLeaderboardLink}
                            targetsConfig={targetsConfig}
                            patronLogo={patronLogo}
                        />
                    </div> :
                    <div className="leaderboard-widget__holding-message">
                        {liveComponentSubtitle}
                    </div>
            }
        </div>
    );
};

export default LeaderboardWidget;
